import Button from './ui/Button';

interface HeroProps {
  onProjectsClick: () => void;
  t: {
    titlePre: string;
    titleInventors: string;
    titleAnd: string;
    titleInvestors: string;
    subtitle: string;
    buttonProjects: string;
    buttonJoin: string;
    buttonInvest: string;
  }
}

const Hero = ({ onProjectsClick, t }: HeroProps) => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative pt-2 pb-2 md:pt-4 md:pb-2 flex items-start justify-center text-center px-4 overflow-hidden">
      <div className="relative z-20 max-w-4xl mx-auto">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight tracking-tighter animate-fade-in-down">
          {t.titlePre} <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-green-400 animate-gradient-text">{t.titleInventors}</span> {t.titleAnd} <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-400 animate-gradient-text">{t.titleInvestors}</span>
        </h1>
        <p className="mt-6 text-lg md:text-xl text-slate-300 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
          {t.subtitle}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up" style={{ animationDelay: '1s' }}>
          <Button id="btn-hero-projects" onClick={onProjectsClick} variant="primary" className="w-full sm:w-auto">
            {t.buttonProjects}
          </Button>
          <Button id="btn-hero-careers" onClick={() => scrollTo('careers')} variant="secondary" className="w-full sm:w-auto">
            {t.buttonJoin}
          </Button>
          <Button id="btn-hero-investors" onClick={() => scrollTo('investors')} variant="accent" className="w-full sm:w-auto">
            {t.buttonInvest}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;